import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { SalesKpiOptions, SalesKpis } from '@domain/sales/models/SalesKpis';

export function useSalesKpis(options?: SalesKpiOptions) {
  const {
    data: salesKpis,
    isLoading,
    error,
  } = useQuery<SalesKpis>({
    queryKey: ['salesKpis', options?.range, options?.weeks],
    queryFn: async () => {
      const result = await container.salesRepository.getSalesKpis(options);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    keepPreviousData: true,
  });

  return {
    salesKpis,
    isLoading,
    error,
  };
}
